import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FacilitatorInfo } from '../components/transfer-visualization/transfer-visualization.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-send-instructions',
    templateUrl: './send-instructions.component.html',
    styleUrls: ['./send-instructions.component.scss'],
    standalone: false
})
export class SendInstructionsComponent {
  @Input() patientId?: string;
  @Input() senderFacility?: string;
  @Input() targetFacility?: string;
  @Input() caseName?: string;
  @Input() facilitators: FacilitatorInfo[] = [];

  constructor(
    private dialog: MatDialog,
    private router: Router
  ) {}

  closeDialog() {
    this.dialog.closeAll();
    this.router.navigate(['/patient-overview-modal', this.patientId]);
    console.log('Dialog closed and navigating to patient overview modal');
  }
}
